import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, ChevronRight } from 'lucide-react';

const LegalLayout = ({ title, lastUpdated, intro, children, testId }) => {
  return (
    <div className="min-h-screen bg-gray-50" data-testid={testId}>
      {/* Header band */}
      <section className="bg-gradient-to-br from-green-700 via-green-700 to-green-800 text-white">
        <div className="max-w-5xl mx-auto px-4 py-14 sm:py-20">
          <div className="flex items-center gap-2 text-green-100 text-sm mb-4">
            <Link to="/" className="hover:text-white flex items-center gap-1">
              <Leaf className="h-4 w-4" /> Daye Farm Ltd
            </Link>
            <ChevronRight className="h-3 w-3" />
            <span>Legal</span>
            <ChevronRight className="h-3 w-3" />
            <span className="text-white font-medium">{title}</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold leading-tight">{title}</h1>
          {lastUpdated && (
            <p className="text-green-100 mt-3 text-sm">
              Last updated: <span className="font-medium text-white">{lastUpdated}</span>
            </p>
          )}
          {intro && (
            <p className="mt-5 text-green-50 leading-relaxed max-w-3xl text-base sm:text-lg">
              {intro}
            </p>
          )}
        </div>
      </section>

      {/* Body */}
      <section className="max-w-5xl mx-auto px-4 py-12 sm:py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-10">
          <article className="prose prose-green max-w-none legal-content">
            {children}
          </article>

          <div className="border-t border-gray-100 mt-12 pt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-500">
            <Link to="/legal/terms" className="hover:text-green-700">Terms & Conditions</Link>
            <Link to="/legal/privacy" className="hover:text-green-700">Privacy Policy</Link>
            <Link to="/legal/cookies" className="hover:text-green-700">Cookie Notice</Link>
            <Link to="/contact" className="hover:text-green-700">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalLayout;
